import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-121" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-122" data-mp="1dx07kidxnd91">
        <SectionHeading id="modules-title" data-id="element-123" data-mp="1dybakfzk0gz3">I {totalVolumes} <span className="text-accent" data-id="element-124" data-mp="2bkihhwjbylem">Volumi Completi</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-125" data-mp="26l5t37ct969x">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-accent/20 bg-background/55 p-6 shadow-lg shadow-black/30" data-id="element-126" data-mp="21k8348lk77xv" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-127" data-mp="1nttjvcg61ciw">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-accent/40 bg-surface/60 text-accent" data-id="element-128" data-mp="18xknqjrknfap">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="1dy8ldoab2udw" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-primary" data-id="element-130" data-mp="103fxo2k9i7w8">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-foreground" data-id="element-131" data-mp="q6tedi7l3owb">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-132" data-mp="v4uy85cu3s8u">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}